import { useState, useEffect } from 'react';
import { supabase } from '../services/supabase';
import { AuthChangeEvent, Session } from '@supabase/supabase-js';
import env from '../config/environment';

export function useAdminStatus() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAdminStatus();

    // Listen for auth state changes
    const { data: { subscription } } = supabase?.auth?.onAuthStateChange(async (_event: AuthChangeEvent, session: Session | null) => {
      if (session?.user) {
        await checkAdminStatus();
      } else {
        setIsAdmin(false);
      }
    }) || { data: { subscription: null } };

    return () => {
      subscription?.unsubscribe();
    };
  }, []);

  const checkAdminStatus = async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      
      if (!user) {
        setIsAdmin(false);
        setLoading(false);
        return;
      }

      // Determine table prefix based on environment
      const tablePrefix = env.isProduction ? 'P_' : 'D_';
      const profilesTable = `${tablePrefix}profiles`;

      // Check if user has admin role
      const { data: profile } = await supabase
        .from(profilesTable)
        .select('role')
        .eq('id', user.id)
        .single();

      const hasAdminRole = profile?.role === 'admin' || profile?.role === 'super_admin';
      setIsAdmin(hasAdminRole);
    } catch (error) {
      console.error('Error checking admin status:', error);
      setIsAdmin(false);
    } finally {
      setLoading(false);
    }
  };

  return { isAdmin, loading };
}